<template>
	<div class="changeOfSeller">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="applySeller()">查询审批进度</el-button>
		</div>

		<el-dialog title="审批进度" :visible.sync="dialogVisible" width="841px" :before-close="onclose">
			<el-table :data="list" style="width: 100%" border>
				<el-table-column label="主体资质" header-align="center" align="center" width="130px">
					<template slot-scope="scope">
						<el-image style="width: 100px; height: 100px" :src="scope.row.subject"
							:preview-src-list="onsrcList(scope.row)">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column label="经营资质" header-align="center" align="center" width="260px">
					<template slot-scope="scope">
						<div class="timgdiv">
							<div v-for="(v,k) in scope.row.business" :key="k">
								<el-image style="width: 100px; height: 100px" :src="v"
									:preview-src-list="scope.row.business">
								</el-image>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" header-align="center" align="center" width="160px">
				</el-table-column>
				<el-table-column prop="state_str" label="状态" header-align="center" align="center" width="80px">
				</el-table-column>
				<el-table-column prop="create_time_str" label="上传时间" header-align="center" align="center" width="170px">
				</el-table-column>
			</el-table>
		</el-dialog>
		<div class="uploadbox" v-if="appdata.myinfo.is_seller != 1">
			<el-form ref="form1" label-width="70px">
				<el-form-item label="主体资质">
					<myupload @resultUrl="onimgurl($event,1)" :uptype="1"></myupload>
				</el-form-item>
				<el-form-item label="经营资质">
					<div class="imgs">
						<img class="img" :src="v" v-for="(v,k) in imageUrl2" :key="k">
						<myupload @resultUrl="onimgurl($event,2)" :uptype="3" :disabled="ondisabled()"></myupload>
					</div>
				</el-form-item>
				<el-form-item label="">
					<el-checkbox v-model="checked">我已阅读</el-checkbox><span class="myjg" @click="ontext">《商家主体及经营资质上传说明》</span>
				</el-form-item>
			</el-form>
			
			<div class="btndiv">
				<el-button type="primary" @click="onOpenSeller()">确认申请</el-button>
			</div>
		</div>

		<div class="text" v-if="appdata.myinfo.is_seller == 1">
			恭喜您，已经成为卖家
		</div>
		
		<el-dialog title="" :visible.sync="textshow" width="900px">
			<ctext></ctext>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'ChangeOfSeller',
		data() {
			return {
				updata: {
					file_name: "",
					file_ext: "",
					file_content: ""
				},
				imageUrl1: "",
				imageUrl2: [],
				dialogVisible: false,
				list: [],
				disabled: false,
				textshow: false,
				checked: false
			}
		},
		inject: ['appdata'],

		mounted() {

		},

		methods: {
			onimgurl(v, n) {
				if (n == 1) {
					this.imageUrl1 = v;
				}

				if (n == 2) {
					this.imageUrl2.push(v);
				}
			},

			onOpenSeller() {
				if (!this.checked) {
					this.$message.warning('请阅读并勾选《商家主体及经营资质上传说明》后申请');
					return
				}
				
				if (!this.imageUrl1) {
					this.$message.warning('请上传您的主体资质');
					return;
				}

				if (this.imageUrl2.length == 0) {
					this.$message.warning('请上传您的经营资质');
					return;
				}

				var obj = {};
				var arr = JSON.parse(JSON.stringify(this.imageUrl2));
				obj.subject = this.imageUrl1;
				obj.business = arr.join(',');
				this.$axios.post('api/user/open_seller', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('提交成功');
						// this.imageUrl1 = "";
						// this.imageUrl2 = [];
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			applySeller() {
				this.$axios.get('api/user/apply_seller').then(res => {
					if (res.data.code == 0) {
						console.log(res.data.data)
						this.list = res.data.data.list;
						if(this.list[0].business) {
							this.list[0].business = this.list[0].business.split(",");
						}
						this.dialogVisible = true;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onclose() {
				this.dialogVisible = false;
			},

			onsrcList(val) {
				var arr = [];
				arr.push(val.subject);
				arr.push(val.business);
				return arr;
			},
			
			ondisabled() {
				if(this.imageUrl2.length<=5) {
					return false
				}else {
					return true
				}
			},
			
			ontext() {
				this.textshow = true;
				this.checked = true;
			}
		}
	}
</script>

<style scoped lang="less">
	.changeOfSeller {
		height: 100%;
	}

	.uploadbox {
		width: 100%;
		box-sizing: border-box;
		padding: 0 80px;
		margin-top: 40px;
	}

	.fbtn {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.text {
		width: 100%;
		height: calc(100% - 52px);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
	}
	
	.imgs {
		display: flex;
		flex-wrap: wrap;
		.img {
			width: 178px;
			height: 178px;
			margin-right: 12px;
			margin-bottom: 12px;
		}
	}
	
	.btndiv {
		width: 100%;
		display: flex;
		justify-content: center;
	}
	
	.timgdiv {
		width: 260px;
		display: flex;
		align-items: center;
		overflow-x: auto;
		> div {
			margin-right: 12px;
		}
	}
	
	.myjg {
		width: 30px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/changeOfSeller.vue